import React, { createContext, useContext, ReactNode } from 'react';
import { useFavorites, UseFavoritesReturn } from './hooks/useFavorites';

const FavoritesContext = createContext<UseFavoritesReturn | undefined>(undefined);

export const FavoritesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const favorites = useFavorites();
  return (
    <FavoritesContext.Provider value={favorites}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useSharedFavorites = (): UseFavoritesReturn => {
  const context = useContext(FavoritesContext);
  if (context === undefined) {
    throw new Error('useSharedFavorites must be used within a FavoritesProvider');
  }
  return context;
};
